const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingAllProducts = () => { const { t } = usePrintful(); return h(ProductCollectionPage, { title: t("h_pf_all_products", "Printful products"), description: t("h_pf_all_products_desc", "Synchronize, filter and import products designed in your Printful store.") }); };
module.exports = { DropshippingAllProducts };
